import { ref } from 'vue';

export const socketActivo = ref(false);

export function setSocketActivo(valor) {
  socketActivo.value = valor;
}

export function isSocketActivo() {
  return socketActivo.value;
}

export function isWebSocketConnected(socketInstance) {
  return !!socketInstance && socketInstance.readyState === WebSocket.OPEN;
}

// Socket instance singleton management
let currentSocket = null;

export function setSocketInstance(socket) {
  currentSocket = socket;
  setSocketActivo(isWebSocketConnected(currentSocket));
}

export function getSocketInstance() {
  return currentSocket;
}

export function closeSocket() {
  try {
    if (currentSocket && currentSocket.readyState === WebSocket.OPEN) {
      currentSocket.close(1000, 'Cierre por inactividad');
    }
  } catch (e) {
    // noop
  } finally {
    setSocketActivo(false);
    currentSocket = null;
  }
}
